import { render, staticRenderFns } from "./IdentityTheftReport.vue?vue&type=template&id=2162c431&"
import script from "./IdentityTheftReport.vue?vue&type=script&lang=js&"
export * from "./IdentityTheftReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports